import { formatStripeAmount } from "@bounce/i18n"

import type { EnrichedGeoIp } from "../getEnrichedGeoIp"

export type BaseGenericInterpolations = {
  COUNTRY_CODE: string
  CURRENCY: string
  PRICE: string
  LOWEST_PRICE: string
  INSURANCE_AMOUNT: string
  NUM_LOCATIONS: string
  NUM_CITIES: string
  NUM_BAGS_STORED: string
}

type GetBaseGenericInterpolationsOptions = {
  enrichedGeoIp: EnrichedGeoIp
  bounceGlobals: {
    bounceShieldProtection: string
    numLocations: string
    numCities: string
    numBagsStored: string
    lowestPricePerDay: string
  }
  language: string
  currency: string
}

export const getBaseGenericInterpolations = ({
  enrichedGeoIp,
  bounceGlobals,
  language,
  currency,
}: GetBaseGenericInterpolationsOptions): BaseGenericInterpolations => {
  const { country, countryDetails, lowestPriceCents } = enrichedGeoIp
  const { bounceShieldProtection, numLocations, numCities, numBagsStored, lowestPricePerDay } = bounceGlobals

  const lowestPrice =
    countryDetails && lowestPriceCents
      ? formatStripeAmount(lowestPriceCents, countryDetails.currency, language)
      : lowestPricePerDay

  return {
    COUNTRY_CODE: country,
    CURRENCY: currency,
    PRICE: lowestPrice,
    LOWEST_PRICE: lowestPrice,
    INSURANCE_AMOUNT: bounceShieldProtection,
    NUM_LOCATIONS: numLocations,
    NUM_CITIES: numCities,
    NUM_BAGS_STORED: numBagsStored,
  }
}
